import React, { useContext, Fragment } from 'react'
import { useQuery } from '@apollo/client'
import { DailyMonitoringFiltersContext } from '../../../../context/DailyMonitoringFiltersContext'
import AutocompleteComponent from '../../../../components/filters/AutocompleteComponent'
import { getCities } from '../../../../queries'

export default function Cities (): JSX.Element {
  const { filters, setFilters } = useContext(DailyMonitoringFiltersContext)
  const { loading, error, data } = useQuery(getCities(filters.states))

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations.cities) return <p>No data found</p>

  const cities: Array<string> = []
  data.ordersAggs.aggregations.cities.buckets.map((city: any) => {
    cities.push(city.key)
  })

  const onChange = (value: any) => {
    setFilters({
      cities: value
    })
  }
  const typographLabel = 'Município'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={cities}
        defaultValues={filters.cities}
        onChange={onChange}
      />
    </Fragment>
  )
}
